import PropTypes from "prop-types";
import React from "react";
import { TagIndicator } from "./TagIndicator";

export const SessionHistoryUserHeaderTag = ({ user }) => {
  if (!user) {
    return null;
  }

  return <TagIndicator label={`User: ${user}`} type={"primary"} />;
};

SessionHistoryUserHeaderTag.propTypes = {
  user: PropTypes.string,
};
